module.exports = __webpack_public_path__ + "img/icon_exchange_complete.53ab5c9a.png";